export const TermsOfService = {
  verbose: `<p>Submitting any request though the Aces Town Car Service reservation system signifies that the client has read the terms and conditions stated below and agrees to all stated terms and conditions.</p>
  
  <h3>Maintenance and Mechanics</h3>
  
  <p>Aces’ is not liable in the event of mechanical breakdown while on charter and will only be responsible for making up lost time at a mutually agreed date. Client assumes full financial liability for any damage to the vehicle caused during the duration of the rental by the client or any members of their party. Total sanitation cost will be assessed by a certified technician and billed to client for spillage of drinks, food, vomiting, etc. Client agrees that smoking and/or alcohol consumption is not permitted in our vehicles. The driver has the right to terminate transportation without refund if there is a blatant indiscretion on the part of a client.</p>
  
  <h3>Charges</h3>
  
  <p>The rate charged for transportation services before wait times and/or tolls.</p>
  
  <h3>Fuel Surcharge</h3>
  
  <p>Fuel surcharge is updated every Monday and based upon the weekly Seattle average price for regular unleaded grade fuel as published by the DOE at <a target="_blank" href="http://tonto.eia.doe.gov/dnav/pet/pet_pri_gnd_dcus_nus_w.htm">http://tonto.eia.doe.gov/dnav/pet/pet_pri_gnd_dcus_nus_w.htm</a></p>
  
  <p>Below $3.00 per gallon 1% Fuel Surcharge<br/>
  $3.01 - $3.25 per gallon 2% Fuel Surcharge<br/>
  $3.26 - $3.50 per gallon 3% Fuel Surcharge<br/>
  $3.51 - $3.75 per gallon 4% Fuel Surcharge<br/>
  $3.76 - $4.00 per gallon 5% Fuel Surcharge<br/>
  $4.01 - $4.25 per gallon 6% Fuel Surcharge<br/>
  $4.26 - $4.50 per gallon 7% Fuel Surcharge<br/>
  $4.51 - $4.75 per gallon 8% Fuel Surcharge</p>
  
  <h3>Wait Time</h3>
  
  <p>All clients receive a 10-minute grace period after time of scheduled service from originating pick-up location, after which, a $1.00 per minute wait charge will be added to base charge for sedan reservations and $1.50 per minute for SUV reservations.</p>
  
  <h3>Estimated Quote</h3>
  
  <p>Rates quoted prior to service are only an initial estimate of cost of services reserved. Change of pickup or dropoff address, wait time, tolls, additional stops and/or additional services may change the final price.</p>
  
  <h3>Weather</h3>
  
  <p>Aces Town Car Service is not responsible for delays or the termination of service in Winter weather which causes unsafe road conditions that could potentially put clients and chauffeurs in danger. Aces' will give proper notification of this weather cancellation to all clients.</p>
  
  <h3>Lost and Found</h3>
  
  <p>Aces will not be held responsible for articles left in vehicles. Personal items that have been left in a vehicle are sometimes returned to the Aces office. Emailing a description of such items to lostandfound@acestowncarservice.com could result in the recovery of such items if they have been found. Recovery of items is not guaranteed.</p>
  
  <h3>Seating Capacity</h3>
  
  <p>Vehicles cannot be loaded beyond seating or luggage capacity. Requesting a vehicle that does not accommodate the number of passengers and/or luggage at pickup location will result in cancellation of service and charged the full base rate.</p>
  
  <h3>Child Safety Seats</h3>
  
  <p>For safety reasons of providing age and weight appropriate equipment, Aces does not provide child safety or booster seats. However, clients may provide and install their own child safety or booster seats. For an explanation of Washington State Child Car Seat Laws, please visit <a target="_blank" href="http://www.dmv.org/wa-washington/safety-laws.php#Child-Car-Seat">http://www.dmv.org/wa-washington/safety-laws.php#Child-Car-Seat</a></p>
  
  <h3>Cancellation and No-Show Policy</h3>
  
  <p>Cancellations must be made no less than four (4) hours in advance to avoid a cancellation charge of the full rate for Point to Points and Airport Transportation reservations. Hourly Bookouts must be cancelled with no less than a twenty-four (24) hour advance notice to avoid a cancellation charge of the full rate. Cancellations due to a cancelled airline flight cannot be made unless given three (3) hours advance notice and verification by Aces of cancellation by airline to avoid a cancellation charge of the full rate. All clients who do not show up for their reserved transportation will be considered a no-show and will be charged the full rate of their reservation.</p>
  
  <h3>Privacy Policy</h3>
  
  <p>Your name and personal information will only be used by Aces' or its contractors for the purpose of rendering service or to collect payments for services rendered. Your email address is used for sending confirmations, information and service enhancements. Our full privacy policy can be found at <a href="http://acestowncarservice.com/privacypolicy" target="_blank">http://acestowncarservice.com/privacypolicy</a></p>
  
  <h3>Terms of Use</h3>
  
  <p>Aces' full Terms of Use can be found at <a href="http://acestowncarservice.com/termsofuse" target="_blank">http://acestowncarservice.com/termsofuse</a></p>`
}



// WEBPACK FOOTER //
// ./src/models/terms_of_service.js